import { create } from "zustand";

interface UserInfo {
  id?: number;
  name?: string;
  email?: string;
  profile_image?: string;
  address?: string;
  account_number?: string;
  country?: string;
  postcode?: string;
  address_detail?: string;
  nickname?: string;
  year?: string;
  month?: string;
  day?: string;
  gender?: string;
  birth_date?: string;
  login_id?: string;
  isSubscribed?: boolean;
  shipping_fee?: number;
  free_shipping_fee?: number;
  toss_customer_key?: string;
  introduction?: string;
  is_exchange_allowed?: boolean;
  is_refund_allowed?: boolean;
  is_return_allowed?: boolean;
  notice?: string;
  account_holder? : string;
  bank_cd? : string;
  shipping_postcode?: string;
  role?: string;
}

interface UserInfoStore {
  userInfo: UserInfo | null;
  setUserInfo: (userInfo: UserInfo) => void;
}

const useUserInfoStore = create<UserInfoStore>((set) => ({
  userInfo: null,
  setUserInfo: (userInfo) => set({ userInfo }),
}));

export default useUserInfoStore;
